/* eslint-disable */
// Define assets path "On The Fly"
__webpack_public_path__ = window.euPortalConfig.assetPath;
/*eslint-enable */

import domainHelp from '../modules/domain-help';
import { fillReferrer } from '../modules/referrer-handler'

const initialize = () => {
    domainHelp();
    fillReferrer();
    import(/* webpackChunkName: "validation-signup-handler" */ '../modules/validation-signup-handler').then(module => {
        const validationHandler = module.default;
        validationHandler('business');
    });
};

export default initialize;
